<template>
    <div class="col-sm-12">
    <h3 v-if="!editMode && !showWizard">
      {{ $t('ins_wizard.select_contract') }}
    </h3>
    <!-- Contract search -->
    <div class="search-form px-3">
      <div class="row">
        <div class="col-sm-4">
          <span class="search-title">{{ $t('contracts.name') }}</span>
            <input
                v-model="name"
                type="text"
                class="form-control form-control-sm"
                id="name"
            />
        </div>
        <div class="col-sm-4">
          <span class="search-title">{{ $t('contracts.number') }}</span>
            <input
                v-model="number"
                type="text"
                class="form-control form-control-sm"
                id="number"
            />
        </div>
        <div class="col-sm-4">
          <span class="search-title">{{ $t('contracts.status') }}</span>
            <div class="form-check mt-1">
                <input
                    type="checkbox"
                    id="open"
                    class="form-check-input"
                    v-model="open"
                />
                <label class="form-check-label- ms-2" for="open">
                    {{ $t('contracts.only_open') }}
                </label>
            </div>
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-sm btn-primary form-button"
          @click.stop="fetchContracts"
        >
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </div>
    <Transition name="fade">
      <div class="col-sm-12 nopads mt-3 pb-3">
        <!-- Show open contracts  -->
        <div
          v-if="!editMode && !showWizard && contracts && contracts.length > 0"
          class="col-12"
        >
          <div
            v-for="item in contracts"
            :key="item.id"
            class="inspection-selector"
            @click.stop="$emit('onContractSelected', item)"
          >
            <span class="title inspection-wizard-selector-text nopads">{{ getTitle(item) }}</span>
            {{ item.customer.name }} - {{ item.contractor.name }}
          </div>
        </div>
      </div>
    </Transition>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import {workManagementHelper} from '../../mixins/WorkManagementMixin'

export default {
    name: 'InspectionContractSelector',
    mixins: [restApi, timeUtils, workManagementHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        onlyElyContracts: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            editMode: false,
            showWizard: false,
            contracts: [],
            loading: false,
            open: 1,
            name: null,
            number: null,
            contract: this.newContract()
        }
    },
    mounted() {
        this.fetchContracts()
    },
    methods: {
        fetchContracts: function () {
            this.contracts = []
            this.loading = true
            let params = {
                open: this.open,
                name: this.name,
                number: this.number
            }
            this.restFetchParams(this.contractUrl, params, this.handleResults)
        },
        handleResults: function (response) {
            this.loading = false
            if (response != null) {
                const data = response.data
                this.contracts = this.onlyElyContracts ? data.filter(x => x.ely_contract) : data
            }
        },
        getTitle(item) {
            let result = item.name
            if (item.contract_number && item.contract_number.length > 0) {
                result += ' - ' + item.contract_number
            }
            return result
        },
        showList() {
            this.editMode = false
            this.fetchOpenContracts();
        }
    }
}
</script>
